/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateCreditCheckoutSessionMutationRequest,
  CreateCreditCheckoutSessionMutationResponse,
  CreateCreditCheckoutSession400,
} from '../types/CreateCreditCheckoutSession'

function getCreateCreditCheckoutSessionUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/contact_request/credits/checkout/` as const,
  }
  return res
}

/**
 * @description Create a checkout session
 * @summary Create a Stripe checkout session to purchase credits
 * {@link /api/v1/contact_request/credits/checkout/}
 */
export async function createCreditCheckoutSession(
  data: CreateCreditCheckoutSessionMutationRequest,
  config: Partial<RequestConfig<CreateCreditCheckoutSessionMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateCreditCheckoutSessionMutationResponse,
    ResponseErrorConfig<CreateCreditCheckoutSession400>,
    CreateCreditCheckoutSessionMutationRequest
  >({
    method: 'POST',
    url: getCreateCreditCheckoutSessionUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
